import { HTMLAttributes } from 'react';
import { ILayoutControl, MaybeStyledCSS } from '@belong/types';
import { DIRECTION, applyFlexLayout, mediaMap } from '@belong/themes';
import styled, { css } from 'styled-components';
import { Fieldset } from '../../forms/Fieldset';

const marginWidth = '0.8rem';

export const ChipsetWrapper = styled(Fieldset)<ILayoutControl & HTMLAttributes<any>>`
  ${applyFlexLayout};
  width: 100%;

  > * {
    // override default margins
    margin: 0 ${marginWidth} ${marginWidth} 0;
  }

  // override top-margin added by fieldset
  > * + *:not([aria-live]) {
    margin-top: 0;
  }

  ${({ hasControl }): MaybeStyledCSS =>
    mediaMap(hasControl, ([direction]) => {
      switch (direction) {
        case DIRECTION.column:
          return css`
            flex-wrap: nowrap;

            > * {
              margin-right: 0;
              width: 100%;
            }
          `;
        case DIRECTION.row:
          return css`
            flex-wrap: wrap;
            > * {
              margin-right: ${marginWidth};
              width: auto;
            }
          `;

        default:
          return css``;
      }
    })};
`;
